import { useTranslation } from "@/hooks/useTranslation";
import { BuildingIcon, UsersIcon } from "lucide-react";
import { memo } from "react";

export const CountBadge = memo(
  ({
    count,
    variant = "company",
  }: {
    count: number;
    variant?: "company" | "employee";
  }) => {
    const { t } = useTranslation();
    if (count === 0) return null;

    const Icon = variant === "employee" ? UsersIcon : BuildingIcon;
    const labelKey =
      variant === "employee"
        ? "prospecting.search.reasoning.employeesFound"
        : "prospecting.search.reasoning.companiesFound";

    return (
      <div className="mt-1.5">
        <span className="inline-flex items-center gap-1 rounded-md border border-border bg-muted px-2.5 py-1 text-xs font-medium text-foreground">
          <Icon className="size-3 shrink-0 text-majorelle" />
          {t(labelKey, { count })}
        </span>
      </div>
    );
  },
);
CountBadge.displayName = "CountBadge";
